export const JAVA_API_URL = `${window.location.origin}/ws`
export const BO_API_URL = `${window.location.origin}/api/v1`
export const BO_API_URL3 = `${window.location.origin}/api/v3`
export const MAIN_API_URL = `${window.location.origin}/api/v2`
export const SHIVA_KNOWLEDGE_BASE_URL = `https://know.test.karmanow.com/api/`
export const FLAGS_BASE_URL = `https://${
  process.env.REACT_APP_HOST || window.location.host
}/images/country-flags`
